<script>
import SearchInput from '@components/search-input/search-input.vue';
import {
  adminPanelComputed,
  adminPanelMethods,
  workoutMethods,
  workoutComputed,
  exerciseDifficultyComputed,
  muscleGroupComputed,
  equipmentComputed,
  equipmentMethods,
  authComputed,
} from '@state/helpers';
import cloneDeep from 'lodash/cloneDeep';

export default {
  components: {
    SearchInput,
  },
  props: {
    hideDescription: {
      type: Boolean,
      required: false,
    },
    showWorkoutFilters: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      selectedWorkoutDifficultyId: null,
      selectedMuscleGroupId: null,
      clearEquipmentSelection: null,
      selectedMuscleGroup: '',
      selectedDifficulty: '',
      initialWorkouts: [],
      isFiltering: false,
      isFilteringResults: false,
      searchComponentKey: 0,
      ownerFilters: ['all'],
      searchOpts: { keys: ['label'] },
      myWorkoutsEnabled: false,
      equipmentType: [],
    };
  },
  computed: {
    ...adminPanelComputed,
    ...workoutComputed,
    ...exerciseDifficultyComputed,
    ...muscleGroupComputed,
    ...authComputed,
    ...equipmentComputed,
    noResults() {
      return {
        title: this.isFiltering
          ? `We couldn't find any results that match your filters. Try changing your filters or search term. Or, if you need to create a new workout, you can go ahead and do that, too.`
          : 'No workouts have been created yet',
        btnText: this.isFiltering ? 'Create New Workout' : 'Add First Workout',
      };
    },
    selectedFilter() {
      return (
        this.ownerFilters &&
        this.ownerFilters.length > 0 &&
        this.ownerFilters[0]
      );
    },
    workouts() {
      let workouts = [];
      if (this.isTrainer) {
        workouts = this.allWorkouts.filter((workout) => {
          const filterName = this.ownerFilters[0];
          if (filterName === 'mine' && workout.trainer_id === this.trainerId) {
            return workout;
          }
          if (filterName === 'sf' && workout.trainer_id === '0') {
            return workout;
          }
          if (filterName === 'all') {
            return workout;
          }
        });
      } else {
        workouts = this.allWorkouts.filter((workout) => {
          if (workout && workout.trainer_id && workout.trainer_id === '0') {
            return workout;
          }
        });
      }

      // Here we do equipment filtering
      if (this.equipmentType && this.equipmentType.length) {
        // if any selected
        workouts = workouts.filter((workout) => {
          // re-assign workouts array
          let matchingWorkout = null;
          if (workout.circuits && workout.circuits.length) {
            workout.circuits.forEach((circuit) => {
              if (circuit.exercises && circuit.exercises.length) {
                circuit.exercises.forEach((exercise) => {
                  const equipments = this.requiredEquipment(exercise); // Get all equipments in that exercise
                  const hasEquipment = equipments && equipments.length;
                  if (hasEquipment) {
                    // Do your thing if a workout has an equipment
                    const matchEquipment = this.equipmentType.every((filter) =>
                      equipments.find(
                        (equipment) => filter._id === equipment._id
                      )
                    );
                    if (matchEquipment) {
                      matchingWorkout = workout;
                    }
                  }
                  // If no equipment and bodyWeight is selected then return anything without weighted equipment
                  if (
                    this.equipmentType &&
                    this.equipmentType.length &&
                    this.equipmentType.find(
                      (equipment) => equipment._id === 'bodyWeight'
                    )
                  ) {
                    const foundWeighted = this.equipmentType.every((filter) =>
                      this.allEquipment.find(
                        (equipment) =>
                          filter._id === equipment._id && equipment.isWeighted
                      )
                    );
                    if (!foundWeighted) {
                      matchingWorkout = workout;
                    }
                  }
                });
              }
            });
          }
          if (matchingWorkout) {
            return matchingWorkout;
          }
        });
      }

      if (this.selectedMuscleGroupId || this.selectedWorkoutDifficultyId) {
        return workouts.filter((workout) => {
          const hasMuscleGroups =
            workout.muscleGroups && workout.muscleGroups.length;
          const exerciseDifficultyId = workout.exerciseDifficulty
            ? workout.exerciseDifficulty.exerciseDifficulty_id
            : null;

          if (this.selectedMuscleGroupId && this.selectedWorkoutDifficultyId) {
            if (hasMuscleGroups) {
              const matchesMuscleGroup = workout.muscleGroups.find(
                (group) => this.selectedMuscleGroupId === group.muscleGroup_id
              );

              if (
                matchesMuscleGroup &&
                exerciseDifficultyId === this.selectedWorkoutDifficultyId
              ) {
                return workout;
              }
            }
          } else if (this.selectedMuscleGroupId) {
            if (hasMuscleGroups) {
              const matchesMuscleGroup = workout.muscleGroups.find(
                (group) => this.selectedMuscleGroupId === group.muscleGroup_id
              );

              if (matchesMuscleGroup) {
                return workout;
              }
            }
          } else if (this.selectedWorkoutDifficultyId) {
            if (exerciseDifficultyId === this.selectedWorkoutDifficultyId) {
              return workout;
            }
          }
        });
      } else {
        return workouts;
      }
    },
    isInSplitPaneFull() {
      return (
        this.panelContent &&
        this.panelContent.data &&
        this.panelContent.data.componentRight &&
        !this.panelContent.data.componentRight.showPanelDetail
      );
    },
    isTrainer() {
      return (
        this.currentUser &&
        this.currentUser.roles &&
        this.currentUser.roles.isTrainer
      );
    },
    allEquipmentSorted() {
      const allEquipmentSortedd = [
        { _id: 'bodyWeight', label: 'Bodyweight' },
        ...this.allEquipment,
      ];
      const sortedArray = allEquipmentSortedd.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      return sortedArray;
    },
  },
  created() {
    this.initialWorkouts = cloneDeep(this.allWorkouts);
    if (!this.allEquipment || !this.allEquipment.length) {
      this.getAllEquipment({ orgId: this.userOrgId, trainerId: '0' });
    }
  },
  mounted() {
    this.clearEquipmentSelection = document
      .getElementById('workoutEquipmentFilter')
      .getElementsByClassName('vs__dropdown-toggle')[0]
      .getElementsByClassName('vs__actions')[0]
      .getElementsByClassName('vs__clear')[0];
    this.clearEquipmentSelection.addEventListener(
      'click',
      this.deselectAllEquipment
    );
  },
  methods: {
    ...adminPanelMethods,
    ...workoutMethods,
    ...equipmentMethods,
    onSelectWorkout(workout) {
      this.$emit('select-library-workout', workout);
      this.setSelectedWorkout(workout);

      if (!this.isInSplitPaneFull) {
        this.setPanelContent({
          ...this.panelContent,
          data: { ...this.panelContent.data, details: workout },
        });
      }
    },
    onSelectMuscleGroup(value) {
      if (value) {
        this.selectedMuscleGroupId = value._id;
        this.selectedMuscleGroup = value.label;
      } else {
        this.selectedMuscleGroupId = null;
        this.selectedMuscleGroup = '';
      }
    },
    onSelectDifficulty(value) {
      if (value) {
        this.selectedWorkoutDifficultyId = value._id;
        this.selectedDifficulty = value.label;
      } else {
        this.selectedWorkoutDifficultyId = null;
        this.selectedDifficulty = '';
      }
    },
    toWorkouts() {
      this.$router.push({ name: 'workouts' }).catch(() => {});
    },
    onFilterResults(val) {
      this.setAllWorkouts(val);
    },
    resetFilters() {
      this.selectedMuscleGroupId = null;
      this.selectedWorkoutDifficultyId = null;
      this.selectedDifficulty = null;
      this.selectedMuscleGroup = null;
      this.setAllWorkouts(this.initialWorkouts);
      this.searchComponentKey++;
    },
    setOwnerFilters(val) {
      this.ownerFilters = [val];
    },
    isSelectedEquipmentType(id) {
      // For the v-select check mark
      return this.equipmentType.find((equipment) => equipment._id === id);
    },
    onSelectEquipmentType(val) {
      // Handle v-select click event
      const index = this.equipmentType.findIndex(
        (item) => item._id === val._id
      );
      if (index === -1) {
        this.equipmentType.push(val);
      } else {
        // Remove if equipment selected
        this.equipmentType.splice(index, 1);
      }
    },
    deselectAllEquipment() {
      this.equipmentType.splice(0, this.equipmentType.length);
    },
    requiredEquipment(exercise) {
      // Helper to get all equipments in the one exercise
      const listOfEquipment = [];
      if (exercise && exercise.requiredEquipment) {
        if (exercise.requiredEquipment.weighted) {
          listOfEquipment.push(exercise.requiredEquipment.weighted);
        }
        if (
          exercise.requiredEquipment.unweighted &&
          exercise.requiredEquipment.unweighted.length
        ) {
          exercise.requiredEquipment.unweighted.forEach((equipment) => {
            listOfEquipment.push(equipment);
          });
        }
      }
      return listOfEquipment;
    },
  },
  watch: {
    isAdminPanelActive(val) {
      if (!val) {
        this.resetFilters();
      }
    },
    isInSplitPaneFull(val) {
      if (!val) {
        this.resetFilters();
      }
    },
    workouts: {
      deep: true,
      handler() {
        if (
          this.selectedMuscleGroupId ||
          this.selectedWorkoutDifficultyId ||
          this.isFilteringResults
        ) {
          this.isFiltering = true;
        }
        if (
          !this.selectedMuscleGroupId &&
          !this.selectedWorkoutDifficultyId &&
          !this.isFilteringResults
        ) {
          this.isFiltering = false;
        }
      },
    },
    equipmentType() {
      this.clearEquipmentSelection.style.display = this.equipmentType.length
        ? 'unset'
        : 'none';
    },
  },
};
</script>

<template>
  <div class="workout-list">
    <div v-if="showWorkoutFilters" class="workout-filters">
      <SearchInput
        :key="searchComponentKey"
        :options="searchOpts"
        :list="initialWorkouts"
        @filter-results="onFilterResults"
      />
      <div class="row">
        <div class="col-3 muscle_group">
          <label for="muscle_group">Muscle Group</label>
          <v-select
            :options="allMuscleGroups"
            :searchable="false"
            :clearable="true"
            :value="selectedMuscleGroup"
            @input="onSelectMuscleGroup"
          />
        </div>
        <div class="col-3 level">
          <label for="muscle_group">Level</label>
          <v-select
            :options="allExerciseDifficulties"
            :searchable="false"
            :clearable="true"
            :value="selectedDifficulty"
            @input="onSelectDifficulty"
          />
        </div>
      </div>
      <div class="row">
        <div class="col equipment">
          <label for="equipment">Equipment</label>
          <v-select
            id="workoutEquipmentFilter"
            multiple
            :class="'tdm-multi-select'"
            :closeOnSelect="false"
            :options="allEquipmentSorted"
            :searchable="false"
            :clearable="false"
            :value="equipmentType"
          >
            <template v-slot:selected-option-container="{ option }">
              <div v-if="equipmentType && equipmentType.length > 1">
                {{ equipmentType.length }} Selected
              </div>
              <div v-else>{{ option.label }}</div>
            </template>
            <template v-slot:option="{ _id, label }">
              <div
                class="option-label-wrapper"
                @click="onSelectEquipmentType({ _id, label })"
              >
                <div>{{ label }}</div>
                <BaseIcon
                  class="icon-check"
                  name="check"
                  v-if="isSelectedEquipmentType(_id)"
                />
              </div>
            </template>
          </v-select>
        </div>
      </div>
      <div v-if="isTrainer" :class="['filter-own-workouts', { inPanel: true }]">
        <span
          id="workoutAllOwnerButton"
          :class="{ selected: selectedFilter === 'all' }"
          @click="setOwnerFilters('all')"
          >All</span
        >
        <span
          id="workoutSFOwnerButton"
          :class="{ selected: selectedFilter === 'sf' }"
          @click="setOwnerFilters('sf')"
          >{{ organizationTitle }} Library</span
        >
        <span
          id="workoutMineOwnerButton"
          :class="{ selected: selectedFilter === 'mine' }"
          @click="setOwnerFilters('mine')"
          >Mine</span
        >
      </div>
    </div>
    <div v-if="workouts.length > 0">
      <BaseListItem
        v-for="(item, i) in workouts"
        :key="i"
        :item="item"
        :hideDescription="hideDescription"
        @select-list-item="onSelectWorkout"
      >
        <slot slot="toBaseListItem">
          <slot name="toWorkoutList" />
        </slot>
      </BaseListItem>
    </div>
    <div class="card-workout-content empty" v-if="workouts.length === 0">
      <div class="add-new-workout-wrapper">
        <p>{{ noResults.title }}</p>
        <BaseButton
          type="button"
          class="btn-primary btn-round btn-ghost"
          @click="toWorkouts"
        >
          <img src="@assets/images/icon-curl.svg" /> {{ noResults.btnText }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

::v-deep .list-item {
  .image-thumbnail {
    min-width: 10rem;
  }
}

.workout-filters {
  margin-bottom: 3rem;

  .search-input-wrapper {
    margin-bottom: 3.2rem;
  }

  .filter-own-workouts {
    align-items: center;
    display: flex;
    justify-content: flex-start;
    span {
      color: rgba($color-black-one-wo-rgb, 0.3);
      cursor: pointer;
      font-family: $base-font-family;
      font-size: 17px;
      font-style: normal;
      font-weight: 900;
      letter-spacing: -0.3px;
      line-height: 24px;
      margin-left: 1.4rem;
      white-space: nowrap;
      &:not(.selected) {
        margin-bottom: 3px;
      }
      &.selected {
        border-bottom: 3px solid $color-action;
        color: $color-black-one;
      }
    }
    &.inPanel {
      span {
        @include calc-font-size(1.5);
      }
      #workoutAllOwnerButton {
        margin-left: unset;
      }
      #workoutMineOwnerButton {
        margin-right: 5px;
      }
    }
  }
}

.card-workout-content {
  min-height: 22.6rem;

  &.empty {
    align-items: center;
    display: flex;
    justify-content: center;
  }
}

.add-new-workout-wrapper {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 75%;
  p {
    font-size: 2.7rem;
    font-weight: 700;
    line-height: 3.2rem;
    padding-bottom: 2rem;
  }
}

.btn-primary {
  white-space: nowrap;
}
</style>
